import { ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';

import { SkeletonBar, SkeletonLayout } from '../styles';

const BAR_HEIGHTS = [
  130, 80, 110, 150, 200, 230, 240, 175, 145, 200, 220, 175, 100, 80, 65,
];

export function StatesBarSkeleton(): ReactElement {
  return (
    <SkeletonLayout>
      {BAR_HEIGHTS.map((h, idx) => (
        <SkeletonBar key={`skeleton-bar-${idx.toString()}`}>
          <Skeleton height={h} borderRadius={4} inline />
        </SkeletonBar>
      ))}
    </SkeletonLayout>
  );
}
